export default __webpack_public_path__ + "static/media/hands.3f77d1e0.webp";